import { ChatMessage } from '@prisma/client'
import { Avatar, Flex } from 'antd'
import React, { useMemo } from 'react'
import { OrganizationMemberClientShared } from '~/features/organizationMember/clientShared'
import { TypingType } from '../../hooks/useParticipantsTyping'
import { LoaderDots } from '../LoaderDots'
import { RenderMarkdownContent } from '../RenderMarkdownContent'

type Props = {
  conversationId: string
  messageParent: ChatMessage
  typing: TypingType
}

export const LiveActions: React.FC<Props> = ({
  conversationId,
  messageParent,
  typing,
}) => {
  const member = useMemo(() => {
    const item = typing[conversationId]

    if (messageParent) {
      if (item?.parentId === messageParent.id) {
        return item
      } else {
        return
      }
    }

    return item
  }, [typing])

  if (!member) {
    return <></>
  }

  const name = OrganizationMemberClientShared.Helper.getName(
    member.organizationMember,
  )
  const pictureUrl = OrganizationMemberClientShared.Helper.getPictureUrl(
    member.organizationMember,
  )
  const contentEnsured =
    name && member.content ? `${name} ${member.content}` : null

  return (
    <>
      <Flex
        className="w-full pl-14"
        vertical
        gap={8}
        style={{ position: 'relative' }}
      >
        <Flex gap={8} className="w-full" style={{ pointerEvents: 'initial' }}>
          {pictureUrl && <Avatar src={pictureUrl} size={20} />}

          {contentEnsured && (
            <RenderMarkdownContent type="secondary" content={contentEnsured} />
          )}

          <Flex style={{ paddingTop: '9px' }}>
            <LoaderDots />
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
